module.exports = __webpack_public_path__ + "static/assets/0e5ebc96e490611948e2e1192062073e.svg";